<div class="app-container flex justify-center items-center">
  <app-no-data [message]="'DEVELOPMENT IS IN PROGRESS'"></app-no-data>
</div>
